<template>
  <div
    class="table-row-holder"
    :class="{'selected': checked}">
    <div
      class="custom-table-row c-float">
      <!-- CHECKBOX -->
      <div v-if="checkbox" class="checkbox-cell">
        <Checkbox
          v-model="checked"
          @change="onChange" />
      </div>

      <div class="data-cell" @click="rowAction">
        <div class="top-row flex">
          <div class="info-box fix-width-position">
            <p class="small-text">{{ formatDate(listItem.pickup_date, 'shipment') }} {{ this.formatTime(listItem.time_from) }} - {{ this.formatTime(listItem.time_until) }}  {{listItem.time_zone ? '(' + listItem.time_zone + ')' : ''}}</p>
            <p class="big-text">
              <span class="cut-text medium">{{ listItem.city }}</span>
              <span class="align-middle">{{ `, ${ countryAlpha2(listItem.country_id) }` }}</span>
            </p>
            <p class="small-text tooltip-holder">
              <span class="cut-text small">{{ listItem.company_name ||  listItem.name}}</span>
              <span class="d-inline-block info-tooltip">
                <Icon
                  v-tooltip="{ ref: 'tooltipRef' }"
                  name="info"
                  size="15" />
            <div class="info-tooltip-window" ref="tooltipRef">
              <p v-if="listItem.company_name">{{ listItem.company_name }}</p>
              <p v-if="listItem.name">{{ listItem.name }}</p>
              <p v-if="listItem.address_1">{{ listItem.address_1 }}</p>
              <p v-if="listItem.address_2">{{ listItem.address_2 }}</p>
              <p v-if="listItem.post_code || listItem.city">{{ `${listItem.post_code} ${listItem.city}` }}</p>
              <p v-if="listItem.state">{{ listItem.state }}</p>
              <p v-if="listItem.country_id">{{ countryName(listItem.country_id) }}</p>
              <p v-if="listItem.phone">{{ `+${listItem.phone}` }}</p>
              <p v-if="listItem.email">{{ listItem.email }}</p>
            </div>
            </span>
            </p>
          </div>
          <div class="middle-box status-box">
            <div
              class="shipment-status-bar"
              :class="statusInfo.class">
              <svg class="stroke-dashed" xmlns="http://www.w3.org/2000/svg">
                <line x1="0" y1="0" x2="100%" y2="0" />
              </svg>
              <div class="icon-point">
                <p class="status-text">{{ statusInfo.text }}</p>
                <Icon
                  :name="statusInfo.icon"
                  size="15" />
              </div>
              <div class="point-one"></div>
              <div class="point-two"></div>
            </div>
            <p class="update-info">
              {{ `${$t('last_update')}` }} <span style="text-transform: lowercase">{{ `${formatDate(listItem.shipment_status_date, 'shipment_last_update')}` }} </span> |
              {{ getStatusMessageText(listItem.shipment_status_message) }}
            </p>
          </div>
          <div class="info-box fix-width-position">
            <p class="small-text">{{ `${listItem.packages_count} colli` }}</p>
            <p class="big-text">
              <span class="medium">{{ parseFloat(listItem.weight ? listItem.weight : 0) | weight }}</span>
            </p>
            <p class="small-text">
              <span class="medium">{{` ${getVolumeText(listItem.vol_dm3)}` }}</span><span style="vertical-align: super;
                        font-size: 10px;
                        line-height: 0px;">3</span>
            </p>
          </div>
        </div>
        <div class="separator medium"></div>
        <div class="bottom-row flex">
          <div class="info-box c-float w-33">
            <LogosSVG :name="listItem.shipping_agent_name" size="45" class="float-left m-r-15" />
            <div class="float-left">
              <div>
                <p class="big-info-text">
                  <span class="m-r-5">{{ listItem.trace_no }}</span>
                </p>
                <p class="small-info-text">{{ listItem.shipping_agent_name }}</p>
              </div>
            </div>
          </div>
          <div class="middle-box c-float w-33">
            <Icon
              :circle=true
              name="hashMark"
              size="17"
              class="float-left m-r-15" />
            <div class="float-left">
              <p class="big-info-text">{{$t('reference')}} : {{ listItem.reference || '-' }}</p>
              <p class="small-info-text">{{ $t('NOTE_TO_DRIVER') }} : {{ listItem.driver_note || '-' }}</p>
            </div>
          </div>
          <div class="info-box fix-width-position c-float w-33 max-w-225">
            <Icon
              :circle=true
              :key="`iconKey-${randomNumber()}`"
              :name="'savedItems'"
              size="20"
              class="float-left m-r-15" />
            <div class="float-left">
              <p class="big-info-text">{{ listItem.shipment_agents }}</p>
              <p class="small-info-text">{{ getGoodsTypesNames(listItem.shipment_goods_types_array) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import mixin from '@/mixins/mixins.js';
import Checkbox from '@/components/elements/inputs/checkbox.vue';
import Btn from '@/components/elements/buttons';
import LogosSVG from "@/assets/images/logosSVG";
import date from '@/mixins/date'

export default {
  name: 'BookedPickupsRow',
  mixins: [mixin, date],
  components: {
    Checkbox, Btn, LogosSVG
  },
  props: [
    'checkbox',
    'checked',
    'listItem',
    'data',
    'rowActionParameter',
    'dropdown',
    'iconKey',
  ],
  data() {
    return {
      selected: false,
      isDropOpened: false,
    };
  },
  computed: {
    statusInfo() {
      if(parseInt(this.listItem.status) === 34){
        return {
          class: 'step1',
          icon: 'clock',
          text: 'Waiting for approval',
        };
      } else if(parseInt(this.listItem.status) === 35){
        return {
          class: 'step1',
          icon: 'checkMan',
          text: 'Approved by carrier',
        };
      } else if(parseInt(this.listItem.status) === 3) {
        return {
          class: 'step1',
          icon: 'printer',
          text: 'Booked',
        };
      } else if (parseInt(this.listItem.status) === 23) {
        return {
          class: 'step1',
          icon: 'ban',
          text: 'Waiting for departure',
        };
      } else if(parseInt(this.listItem.status) === 5) {
        return {
          class: 'step1',
          icon: 'deleteForever',
          text: 'Canceled',
        };
      } else if(
        parseInt(this.listItem.status) === 4 ||
        parseInt(this.listItem.status) === 13 ||
        parseInt(this.listItem.status) === 17 ||
        parseInt(this.listItem.status) === 12) {
        return {
          class: 'step2',
          icon: 'delivery',
          text: 'Transit',
        };
      } else if(parseInt(this.listItem.status) === 43) {
        return {
          class: 'step2',
          icon: 'delivery',
          text: this.$t('picked_up')
        };
      } else if(parseInt(this.listItem.status) === 16) {
        return {
          class: 'step3',
          icon: 'warning',
          text: 'Deviation',
        };
      } else if (parseInt(this.listItem.status) === 15) {
        return {
          class: 'step3',
          icon: 'pin',
          text: this.$t('In Pickup Point'),
        };
      } else if(parseInt(this.listItem.status) === 14) {
        return {
          class: 'step4',
          icon: 'check',
          text: this.$t('completed'),
        };
      } else {
        console.log('Booked pickups page: Status not supported');
      }
    },
  },
  methods: {
    getStatusMessageText(message, breakpoint, part) {
      //Translate first index of array
      if (message && message.includes('@separator0@')) {
        const statusMsgArray = message.split('@separator0@');
        return `${this.$t(statusMsgArray[0])} ${statusMsgArray[1]}`;
      }

      if (breakpoint && message.includes(breakpoint)) {
        const statusMsgArray = message.split(breakpoint);
        const translationString = statusMsgArray[part] ? statusMsgArray[part].trim() : '';
        return `${this.$t(translationString)}`;
      }

      return `${this.$t(message)}`
    },
    randomNumber() {
      return Math.floor(100000 + Math.random() * 900000);
    },
    rowAction() {
      this.$router.push(`/pickups/booked/${this.listItem.id}`);
    },
    countryName(id){
      return this.getCountry(id, 'name');
    },
    countryAlpha2(id) {
      return this.getCountry(id, 'alpha2');
    },
    onChange() {
      this.$emit('updateSelect', this.listItem.id);
    },
    getGoodsTypesNames(goodsTypes) {
      let result = [];
      goodsTypes.forEach((goodsType) => {
        if (this.goodTypeName(goodsType)) {
          result.push(this.$t(this.goodTypeName(goodsType).name));
        }
      })

      return result.join(', ');
    },
    goodTypeName(type) {
      if(parseInt(type) === 1) {
        return {
          name: 'Parcel',
          icon: 'savedItems',
        };
      }
      if(parseInt(type) === 2){
        return {
          name: 'Document',
          icon: 'documentGoods',
        };
      }
      if(parseInt(type) === 3){
        return {
          name: 'Pallet',
          icon: 'pallet',
        };
      }
      if(parseInt(type) === 4){
        return {
          name: 'Load',
          icon: 'delivery',
        };
      }
    },
    linkCall(val) {
      window.open(val, '_blank');
    },
  },
}
</script>
